import { getApi } from "./apiService";


// Public-friendly route: works during registration (before merchant approval)
// and post-approval for product management.
export const getCategories = async () => {
    return await getApi("/ma/category/get-all")
}
export const getTypes = async () => {
    return await getApi("/ma/category/types")
}
export const getCategoriesByType = async (typeId) => {
    return await getApi(`/ma/category/by-type?type=${typeId}`)
}
export const getSubCategories = async (categoryId) => {
    return await getApi(`/ma/category/sub-category?category=${categoryId}`)
}

export const getBrands = async (categoryId) => {
    return await getApi(`/mp/brand/get-all?categoryId=${categoryId}`)
}